export default __webpack_public_path__ + "static/media/DAIF_UseCase_Screen4_in-end.f4795b21.jpg";